import { useParams } from "react-router-dom";
import { selectTournament } from "selectors/Tournament";
import { TournamentLoader } from "pages/TournamentLoader";
import { TournamentPageContent } from "./TournamentPageContent";
import { ErrorMessagePage } from "pages/PageTemplates";
import { useAppSelector } from "app/hooks";

export const TournamentPage = () => {
  const { id, tabName } = useParams();

  // todo - resolving tournament like this ok?
  // if so make use of injection downwards instead of re-resolving, since this selector will cause refresh on change regardless
  const tournament = useAppSelector((state) => selectTournament(state, id));

  if (!tournament || !id) {
    return <ErrorMessagePage message="Tournament Could Not Be Found" />;
  }

  return (
    <TournamentLoader tournamentIds={[id]}>
      <TournamentPageContent tournament={tournament} tabName={tabName} />
    </TournamentLoader>
  );
};
